import { ProgressBar, WarningIcon } from "@commonlibs";
import { Button } from "@commonlibs";
import styled, { css } from "styled-components";
import FileUpload from "ui/common/components/input/FileUpload/FileUpload";
import CircleCheckIcon from "ui/common/icons/CircleCheckIcon";
// import CircleCheckIcon from "ui/common/icons/CircleCheckIcon";

export const ExplanationSection = styled.div(({ theme }) => {
    return css`
        padding: 1rem;
        background-color: #43398e1e;
        border-radius: 12px;
        ${theme.typography.body3Strong.style};
        & a {
            color: ${theme.palette.primary};
            text-decoration: underline;
        }
    `;
});

export const UploadSection = styled.div(({ theme }) => {
    return css`
        height: 115px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border: 1px dashed #c0c0c0;
        border-radius: 12px;
        ${theme.typography.body3Regular.style};
    `;
});

export const FileUploadRoot = styled(FileUpload)(() => {
    return css`
        width: 100%;
        .upload-input-display {
            padding: 1rem;
            background: none;
        }
    `;
});

export const CancelButton = styled(Button)(({ theme }) => {
    return css`
        border: 2px solid #26262614;
        color: #27292b !important;
        background-color: white !important;
        min-width: 230px;
        :hover {
            background-color: ${theme.palette.primary} !important;
            color: white !important;
        }
    `;
});

export const UploadButton = styled(Button)(() => {
    return css`
        min-width: 230px;
    `;
});

export const UploadedFiles = styled.div(() => {
    return css`
        padding-top: 8px;
        border-top: 1px solid #d4d4d4;
        margin-bottom: 20px;
    `;
});

export const DeleteFileButton = styled.button(
    () => css`
        border: none;
        padding: 0px;
        background: none;
        cursor: pointer;
        font-size: 1.5rem;
    `,
);

export const FileUploadLoading = styled.div(
    () => css`
        width: 100%;
        height: 100%;
        display: flex;
        gap: 5px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #eeeeee;
        border-radius: 12px;
    `,
);

export const ProgressBarRoot = styled(ProgressBar)(
    ({ theme }) => css`
        color: ${theme.palette.green["200"]};
        width: 75%;
    `,
);

export const FileUploadSuccess = styled.div(
    () => css`
        width: 100%;
        height: 100%;
        display: flex;
        gap: 5px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #30c3a326;
        border-radius: 12px;
    `,
);

export const FileUploadError = styled.div(
    () => css`
        width: 100%;
        height: 100%;
        display: flex;
        gap: 5px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #db555528;
        border-radius: 12px;
    `,
);

export const CheckIconRoot = styled(CircleCheckIcon)(
    ({ theme }) => css`
        color: ${theme.palette.green["200"]};
        font-size: 25px;
    `,
);

export const WarningIconRoot = styled(WarningIcon)(
    ({ theme }) => css`
        color: ${theme.palette.red};
        font-size: 25px;
    `,
);
